import { useState } from "react";
import { BaseService } from "@services/BaseService";
import environment from "environment";
import { CustomerCommercialCriteriaAddRequestV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers/customerCommercialCriteriaAddRequestV1";

const useCreateEditCommercialCriteria = () => {
  const [isCommercialCriteriaSubmitting, setIsCommercialCriteriaSubmitting] =
    useState(false);

  const [error, setError] = useState<string>();

  const submitCreateCommercialCriteria = (
    data: CustomerCommercialCriteriaAddRequestV1 & { orgId: string }
  ) => {
    return new Promise(function (resolve, reject) {
      setIsCommercialCriteriaSubmitting(true);
      setError("");
      const apiUrl =
        environment.api.organisationInfo +
        `/${data.orgId}` +
        "/commercialcriterias";

      BaseService.post(apiUrl, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          switch (err.response.data.errorCode) {
            case "IR0003":
              setError("Commercial Criteria name already exists");
              break;
            case "IR0002":
              setError(
                "Combination of number type, service type and use case already exists, please try another combination."
              );
              break;
            default:
              setError(err?.message);
              break;
          }
          reject(err?.message);
        })
        .finally(() => {
          setIsCommercialCriteriaSubmitting(false);
        });
    });
  };

  return {
    isCommercialCriteriaSubmitting,
    submitCreateCommercialCriteria,
    error,
    setError,
  };
};

export default useCreateEditCommercialCriteria;
